import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import Auth from "../../auth/Auth";
import { IStore } from "../../models/IStore";

export interface ICallbackSamlQaNaProps extends RouteComponentProps {
  auth: Auth;
}

export class CallbackSamlQaNa extends React.Component<ICallbackSamlQaNaProps> {
  public constructor(props: ICallbackSamlQaNaProps) {
    super(props);
  }

  public componentDidMount() {
    const { auth } = this.props;

      auth.loginSAMLQaNa().then(() => {
          console.log("Login via SAML QA North America");
    });
  }

  public render() {
    return <div>Loading...</div>;
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    auth: state.auth0
  };
};

export default connect(mapStateToProps)(CallbackSamlQaNa);
